import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { baseUrl } from '../../utils/baseUrl.js'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "./../../index.css";
import "./../../mainslider.css"
import { Navigation } from "swiper";
import { Link } from 'react-router-dom';
import { AiOutlineDoubleRight } from 'react-icons/ai';



export const CategoriesNav = () => {


    const [categories, setCategories] = useState([])

    const getBrand = async () => {
        const { data } = await axios.get(`${baseUrl}/categories`)
        setCategories(data.categories)
    }

    useEffect(() => {
        getBrand()
    }, [])

    return (
        <div className="bg-slate-100  mx-auto shadow-md border-t border-slate-400 text-xs font-semibold select-none">
            {categories ?
                <div className="flex">
                    <h2 className="text-lg sm:text-xl md:text-2xl p-2 flex items-center gap-2 shadow-custom bg-slate-200">Categories <AiOutlineDoubleRight  size={20}/></h2>
                    <Swiper
                        breakpoints={{
                            // 375: {
                            //     width: 375,
                            //     slidesPerView: 1,
                            // },
                            427: {
                                width: 427,
                                slidesPerView: 2,
                            },
                            576: {
                                width: 576,
                                slidesPerView: 3,
                            },
                            768: {
                                width: 768,
                                slidesPerView: 4,
                            },
                            1024: {
                                width: 1024,
                                slidesPerView: 5,
                            },
                            2048: {
                                width: 2048,
                                slidesPerView: 6,
                            },
                        }}
                        modules={[Navigation]}
                        // slidesPerView={9}
                        spaceBetween={20}
                        // loop={true}
                        // navigation={{ clickable: true }}
                        className="select-none m-auto">
                        {categories.map((category, i) => (
                            <SwiperSlide key={i} className="text-slate-800 w-max cursor-pointer tracking-wider bg-amber-400">
                                <Link className="bg-gray- py-3" to={`/categories/${category._id}`}>
                                    {`${category.name?.charAt(0).toUpperCase() + category.name?.slice(1)}`}
                                </Link>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div> : ""}
        </div>
    )
}
